module.exports = __webpack_public_path__ + "img/ring_r_e_0_1@2x.d0dc9db6.png";